import { useQuery } from "@tanstack/react-query";
import { designSystemApi } from "./design-system.api";
import { designSystemKeys } from "./design-system.keys";

export const useGetThemesQuery = ({ enabled }: { enabled?: boolean }) => {
  return useQuery({
    queryKey: designSystemKeys.themes,
    queryFn: () => designSystemApi.getThemes(),
    enabled: !!enabled,
  });
};

export const useGetThemeByIdQuery = (id: string) => {
  return useQuery({
    queryKey: designSystemKeys.theme(id),
    queryFn: () => designSystemApi.getThemeById(id),
    enabled: !!id,
  });
};
